// removed by extract-text-webpack-plugin
module.exports = {"footer":"src-components-modules-Footer-style----general-module---footer---128bX bg-licorice c-white","divider":"src-components-modules-Footer-style----general-module---divider---1T0gD bg-steel"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/Footer/style/general.module.css
// module id = 1453
// module chunks = 168707334958949